export default __webpack_public_path__ + "static/media/passed.1ec19f39.svg";